(function () {
    'use strict';

    var consumptionUnit = {
        template: '{{ $ctrl.consumption.consumption }} {{ $ctrl.consumption.unit }}',
        bindings: {
            consumption: '<'
        }
    };

    var statisticUnit = {
        template: '{{ $ctrl.statistic.value }} {{ $ctrl.statistic.unit }}',
        bindings: {
            statistic: '<'
        }
    };

    angular.module('swif.fluid')
        .component('consumptionUnit', consumptionUnit)
        .component('statisticUnit', statisticUnit);

})();
